import React from 'react'
import PropTypes from 'prop-types'

const ListAddIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M9.75 7.25H2.25C1.8375 7.25 1.5 7.5875 1.5 8C1.5 8.4125 1.8375 8.75 2.25 8.75H9.75C10.1625 8.75 10.5 8.4125 10.5 8C10.5 7.5875 10.1625 7.25 9.75 7.25ZM9.75 4.25H2.25C1.8375 4.25 1.5 4.5875 1.5 5C1.5 5.4125 1.8375 5.75 2.25 5.75H9.75C10.1625 5.75 10.5 5.4125 10.5 5C10.5 4.5875 10.1625 4.25 9.75 4.25ZM13.5 10.25V8C13.5 7.5875 13.1625 7.25 12.75 7.25C12.3375 7.25 12 7.5875 12 8V10.25H9.75C9.3375 10.25 9 10.5875 9 11C9 11.4125 9.3375 11.75 9.75 11.75H12V14C12 14.4125 12.3375 14.75 12.75 14.75C13.1625 14.75 13.5 14.4125 13.5 14V11.75H15.75C16.1625 11.75 16.5 11.4125 16.5 11C16.5 10.5875 16.1625 10.25 15.75 10.25H13.5ZM2.25 11.75H6.75C7.1625 11.75 7.5 11.4125 7.5 11C7.5 10.5875 7.1625 10.25 6.75 10.25H2.25C1.8375 10.25 1.5 10.5875 1.5 11C1.5 11.4125 1.8375 11.75 2.25 11.75Z"
        fill={color}
      />
    </svg>
  )
}

ListAddIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ListAddIcon)
